<div style="font-size: 28px; font-weight: 700; padding: 30px 0 0px 0; text-align: center; color: #29323A">
	Create Your Parent Account
</div>
<div style="font-size: 16px; font-weight: 300; padding: 0 0 20px 0; text-align: center; color: #65727D">
	Trusted by 37,000+ Muslim families
</div>
<div class="google-signIn">
	<button (click)="loginViaGoogle()" type="button">
		<img style="vertical-align: text-bottom;" width="21" src="assets/images/google-sign.png" alt="SignInWithGoogle" />
		<span style="margin-left: 8px; color: #52595F; font-size: 16px; font-family: 'Outfit'; font-weight: 500">Continue with Google</span>
	</button>

	<button (click)="loginViaApple()" type="button" style="margin-top: 10px;">
		<img style="vertical-align: text-bottom;" width="21" src="assets/images/apple-sign.png" alt="SignInWithApple" />
		<span style="margin-left: 7px; color: #52595F; font-size: 16px; font-family: 'Outfit'; font-weight: 500">Continue with Apple</span>
	</button>
</div>

<div class="line-hr"><div>or</div></div>
@if (loginFaild) {
<p class="text-danger">{{loginFaild}}</p>
}
<form (submit)="!registrationForm?.invalid && registration()">

	<div class="row">
		<div class="col-md">
			<div style="font-size: 16px; font-weight: 300; padding: 0 0 15px 0; text-align: start; color: #65727D">
				You’ll use this email to log in.
			</div>
			<mat-form-field class="full-width custom-height-input" appearance="fill" subscriptSizing="fixed">
				<input autofocus matInput [formControl]="email" [errorStateMatcher]="matcher" placeholder="Email">
				@if (email.hasError('email') && !email.hasError('required')) {
				<mat-error>
					Please enter a valid email address
				</mat-error>
				}
				@if (email.hasError('required')) {
				<mat-error>
					Email is <strong>required</strong>
				</mat-error>
				}
			</mat-form-field>
		</div>
	</div>

	<div class="row">
		<div class="col-md">
			<mat-form-field class="full-width custom-height-input" appearance="fill" subscriptSizing="fixed">

				<input matInput autocomplete="new-password" [type]="hide ? 'password' : 'text'" [formControl]="password" [errorStateMatcher]="matcher" placeholder="Password">

				<button mat-icon-button
						matSuffix
						(click)="hide = !hide"
						type="button"
						[attr.aria-label]="'Hide password'"
						[attr.aria-pressed]="hide">

					<!-- Toggles the icon visually -->
					<mat-icon>{{ hide ? 'visibility_off' : 'visibility' }}</mat-icon>
				</button>

				@if (password.hasError('required')) {
				<mat-error>
					Password is <strong>required</strong>
				</mat-error>
				}
				@if (password.hasError('minlength')) {
				<mat-error>Password must have at least 8 characters</mat-error>
				}
			</mat-form-field>
			<div>
				<mat-checkbox class="custom-checkbox" [formControl]="terms">
					<div style="color: #65727D; font-weight: 300; font-size: 14px">
						I agree to the <a href="https://quranera.com/terms-of-service.html" target="_blank" style="color: #CC7A00; font-weight: 400; text-decoration: underline; font-family: 'Outfit' !important; ">Terms of Use</a>
						and <a href="https://quranera.com/privacy-policy.html" target="_blank" style="color: #CC7A00; font-weight: 400; text-decoration: underline; font-family: 'Outfit' !important; ">Privacy Policy</a>
					</div>
				</mat-checkbox>
				<mat-error style=" padding-left: 25px; min-height: 18px; font-weight: 400" [style.visibility]="(terms.hasError('required') && terms.touched) ? 'visible' : 'hidden'">
					You must agree to the Terms of Use and Privacy Policy.
				</mat-error>
			</div>
		</div>
	</div>

	<button type="submit" class="btn-3d btn-large btn-full-width" style="margin: 10px 0 30px 0" (click)="registrationForm.markAllAsTouched()">Create Account</button>
</form>
<div class="m-0" style="text-align: center; font-weight: 300; color: #65727D">Already have an account? <a href="/login" style="color: #CC7A00 !important; font-weight: 500">Log in here</a></div>
